import { AccessTime, CarRental } from "@mui/icons-material";
import { Link, Stack, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import dayjs from "dayjs";
import { useWatch } from "react-hook-form";

import { ILocation, RentalLocationType } from "../../../../../types";
import { IFormValues } from "../../../types";

const LocationHelperText = ({
    location,
    locationType
}: {
    location: ILocation | null,
    locationType: RentalLocationType
}) => {

    const { t } = useTranslation('booking');

    const pickupDate = useWatch<IFormValues, 'basicDetails.pickupDate'>({
        name: 'basicDetails.pickupDate'
    });

    if (!location) {
        return null;
    }

    return (
        <Stack direction="row" justifyContent="space-between" alignItems="start">
            <Link
                component={RouterLink}
                to={`/mobility-store/dms-detail/${location.ntwId}`}
                target="_blank"
            >
                {t('label.dmsInfo')}
            </Link>
            <Stack direction="row" alignItems="center" columnGap={.5}>
                {((location?.afterHours && locationType === RentalLocationType.Pickup) ||
                    (locationType === RentalLocationType.Pickup && !!pickupDate && pickupDate.format("YYYY-MM-DD") === dayjs().format("YYYY-MM-DD") )) &&
                    <Tooltip
                        title={t('label.afterHours')}
                    >
                        <AccessTime
                            fontSize="medium"
                            color="secondary"
                        />
                    </Tooltip>
                }
                {locationType === RentalLocationType.Dropoff && location?.keybox &&
                    <Tooltip
                        title={t('label.keyBox')}
                    >
                        <CarRental
                            fontSize="medium"
                            color="secondary"
                        />
                    </Tooltip>
                }
            </Stack>
        </Stack>

    );

    /* return (
        <Stack direction="row" justifyContent="space-between" alignItems="start">
            <Box>
                <Typography variant="caption" color="inherit" component="div">
                    <b>{t('label.week')}: </b>
                    {parsedOpenings ? renderTimeRanges(parsedOpenings.week) : ''}
                </Typography>
                <Typography variant="caption" color="inherit" component="div">
                    <b>{t('label.saturday')}: </b>
                    {parsedOpenings ? renderTimeRanges(parsedOpenings.sat) : ''}
                </Typography>
                <Typography variant="caption" color="inherit" component="div">
                    <b>{t('label.sunday')}: </b>
                    {parsedOpenings ? renderTimeRanges(parsedOpenings.sun) : ''}
                </Typography>
            </Box>
            <Stack direction="row" alignItems="center" columnGap={.5}>
                {location?.afterHours &&
                    <Tooltip title="After Hours">
                        <AccessTime
                            fontSize="medium"
                            color="secondary"
                            sx={{
                                p: '5px'
                            }}
                        />
                    </Tooltip>
                }
                {locationType === 'dropoff' && location?.keybox &&
                    <>
                        <Tooltip title="Keybox">
                            <IconButton
                                onClick={popper.handleShow}
                                color="secondary"
                            >
                                <CarRental fontSize="medium" />
                            </IconButton>
                        </Tooltip>
                        <Popover
                            open={popper.open}
                            anchorEl={popper.anchorEl}
                            onClose={popper.handleClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <Box p={2}>
                                <Typography variant="caption" component="div">
                                    <b>{t('label.week')}: </b>
                                    {parsedTimeframes ? renderTimeRanges(parsedTimeframes.week) : ''}
                                </Typography>
                                <Typography variant="caption" component="div">
                                    <b>{t('label.saturday')}: </b>
                                    {parsedTimeframes ? renderTimeRanges(parsedTimeframes.sat) : ''}
                                </Typography>
                                <Typography variant="caption" component="div">
                                    <b>{t('label.sunday')}: </b>
                                    {parsedTimeframes ? renderTimeRanges(parsedTimeframes.sun) : ''}
                                </Typography>
                            </Box>
                        </Popover>
                    </>
                }
            </Stack>
        </Stack>
    ); */
};

export default LocationHelperText;
